export const encodeEntity = (topic: string) => {
  return encodeURIComponent(topic).replaceAll('.', '%2E');
};

export const capitalize = (str: string) => {
  return str?.replace(/#/, '').replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
};
